import React from 'react';
import Accordion from '../accordion/Accordion';
import classNames from 'classnames';
import * as classes from './StudentAccordion.module.scss';

function StudentAccordion({ className, theme, heading }) {
  return (
    <div
      className={classNames({
        [className]: className,
        [classes.wrapper]: true
      })}
    >
      <Accordion
        id="students"
        heading={heading || 'Are you an international student in the UK applying for an account?'}
        theme={theme}
      >
        <p>Having the right documents to hand will help speed up your application. </p>

        <p>
          When you apply for a current account with us, we’ll need proof of identity and proof of your address. As an
          international student, we accept letters from your university that confirm your term time address.
        </p>

        <p>
          Your university letter must be from a recognised university, and you must be living at the address on the
          letter. We’ll need to be able to match your student housing address to the address in your application. If
          you’re living in a flat, or room number is needed, you’ll need to follow this format:{' '}
        </p>

        <p>
          Line 1: Flat or Room 1<br />
          Line 2: 12 Smithe Street
          <br />
          Line 3: Optional
          <br />
          Post Town: Glasgow
          <br />
          Postcode: G1 1AA
        </p>

        <p>
          We can also accept a tenancy agreement, as long as it is from a solicitor, housing association, local council
          or letting agency. We can’t accept a private agreement between you and the landlord.{' '}
        </p>

        <p>
          Your tenancy must have already started, and last for a minimum of six months. So for example if today is the
          24th August, we wouldn’t be able to accept a tenancy agreement that starts any date after the 24th August.{' '}
        </p>
      </Accordion>
    </div>
  );
}

export default StudentAccordion;
